<template>
  <v-layout wrap>
    <v-flex sm12 class="white--text">
      <p>{{ participant.name }}</p>
    </v-flex>
    <v-flex sm12 class="white--text">
      <p>{{ participant.work }}</p>
    </v-flex>
    <v-flex sm6 offset-sm3>
      <v-card height="50vh" class="pa-6">
        <v-layout v-if="activeCard" wrap style="height:100%">
          <v-layout wrap v-if="!finished">
            <v-flex sm10>
              <p class="text-justify">{{ reactives[actual].title }}</p>
            </v-flex>

            <v-flex sm2>
              {{ timer }}
              <v-icon>mdi-alarm</v-icon>
            </v-flex>
            <v-layout wrap class="d-flex align-end mb-12">
              <v-flex sm12 class="text-center">
                <v-btn @click="addAnswer(1)" class="primary">Si</v-btn>
              </v-flex>
              <v-flex sm12 class="text-center">
                <v-btn @click="addAnswer(0)" class="primary">No</v-btn>
              </v-flex>
            </v-layout>
          </v-layout>
          <div v-else style="text-align:center">
            <p>Has terminado</p>

            <v-btn @click="exit" class="primary">Salir</v-btn>
          </div>
        </v-layout>
        <v-layout wrap v-else>
          <p>Cargando..</p>
        </v-layout>
      </v-card>
    </v-flex>

    <v-snackbar v-model="snackbar" right top :timeout="3000">
      {{ message }}
      <v-btn color="blue" text @click="snackbar = false">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-snackbar>
  </v-layout>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      editor: null,
      snackbar: false,
      reactives: [],
      answers: [],
      activeCard: false,
      message: "",
      actual: 0,
      timer: 0,
      finished: false,
      idInterval: null,
      participant: JSON.parse(sessionStorage.getItem("participant")),
      host: process.env.VUE_APP_HOST
    };
  },
  methods: {
    exit() {
      window.location = "https://www.google.com";
    },
    send() {
      this.finished = true;
      const fd = new FormData();

      for (let i = 0; i < this.answers.length; i++) {
        fd.append("answers[]", this.answers[i]);
        fd.append("idReactives[]", this.reactives[i].idReactive);
      }

      fd.append("idParticipant", this.participant.idParticipant);
      fd.append("idUser", this.$route.params.idUser);
      fd.append("date", new Date() + "");

      axios
        .post(this.host + "/answers/create.php", fd)
        .then(response => {
          this.snackbar = true;
          this.message = response.data.message;
          if (response.data.status) {
            sessionStorage.removeItem("participant");
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    addAnswer(val) {
      this.answers.push(val);
      this.actual++;

      if (this.answers.length < this.reactives.length) {
        clearInterval(this.idInterval);

        if (
          this.answers[0] == 0 &&
          this.answers[1] == 0 &&
          this.answers[2] == 0 &&
          this.answers[3] == 0 &&
          this.answers[4] == 0 &&
          this.answers[5] == 0
        ) {
          this.send();
        } else {
          if (this.reactives[this.actual].timer == 0) {
            this.timer = 0;
          } else {
            this.timer = this.reactives[this.actual].timer;
            this.timerFunction();
          }
        }
      } else {
        //se acabaron las preguntas
        clearInterval(this.idInterval);
        this.send();
      }
    },
    timerFunction() {
      this.idInterval = setInterval(() => {
        if (this.timer <= 1) {
          clearInterval(this.idInterval);
          this.timer = 0;
          this.addAnswer(0);
        } else {
          this.timer--;
        }
      }, 1000);
    },
    getData() {
      this.activeCard = false;
      axios
        .get(this.host + "/reactives/read.php")
        .then(response => {
          this.reactives = response.data.data;
          this.activeCard = true;
          this.timer = this.reactives[this.actual].timer;
          // this.timerFunction()
        })
        .catch(error => {
          console.log(error);
        });
    },
    createFormData(postData) {
      let formDa = new FormData();
      for (let key in postData) {
        formDa.append(key, postData[key]);
      }
      return formDa;
    }
  },
  mounted() {
    this.getData();
  }
};
</script>

<style scoped>
.background {
  position: relative;
  background-color: rgba(0, 0, 0, 0.5);
  height: 95%;
  width: 100%;
  z-index: 100;
}
.front {
  position: relative;
  z-index: 10;
}
</style>